<template>
  <v-textarea
    data-test-id="primaryTextAreaInput"
    v-bind="$attrs"
    style="margin-bottom: 0.25rem"
    v-model="model"
    v-if="mode === EditorMode.Edit"
    color="primary"
    :rows="rows"
    :no-resize="true"
    density="comfortable"
    :max-rows="rows"
    :label="label"
    counter
    variant="outlined"
  >
    <template v-slot:label>
      <span>{{ label }}&nbsp;<span v-if="required" class="required-text">*</span></span>
    </template>

    <!-- @vue-skip -->
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData"
      ><slot :name="name" v-bind="slotData"
    /></template>
  </v-textarea>
  <DisplayText v-else data-test-id="primaryTextAreaInputDisplay" :value="model" :label="label" />
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { EditorMode } from '@/enums/EditorMode'
import type { PropType } from 'vue'

// PROPS & EMITS
defineProps({
  required: { type: Boolean, default: false },
  label: { type: String, default: '' },
  mode: { type: String as PropType<EditorMode>, default: EditorMode.Edit },
  rows: { type: Number, default: 3 }
})

// REACTIVE VARIABLES
const model = defineModel()

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
</script>
